// Hook - szczegoly skrzynki mailowej zalogowanego handlowca
// GET /api/ui/sales-crm/mailbox/my-mailbox

import { axios } from 'api';
import { useQuery, UseQueryOptions } from 'react-query';
import { ICommandResponseError as IError } from 'api/types';
import type { IGetMyMailboxResponse } from 'api/types/mailbox';

export const getMyMailboxQueryKey = ['sales-crm-mailbox', 'my-mailbox'] as const;

const getMyMailbox = (): Promise<IGetMyMailboxResponse> =>
  axios.get('/sales-crm/mailbox/my-mailbox');

export const useGetMyMailbox = (
  options?: UseQueryOptions<IGetMyMailboxResponse, IError>
) =>
  useQuery<IGetMyMailboxResponse, IError>(
    getMyMailboxQueryKey,
    () => getMyMailbox(),
    options
  );
